import { useState } from "react"
import { Button } from "@/components/ui/button"
import { 
  Tabs, 
  TabsList, 
  TabsTrigger, 
  TabsContent 
} from "@/components/ui/tabs"

// Import refactored components
import { FilterBar } from "./overtime/FilterBar"
import { OvertimeList } from "./overtime/OvertimeList"
import { ChartView } from "./overtime/ChartView"
import { SummaryView } from "./overtime/SummaryView"

interface OvertimeHistoryProps {
  employee: {
    id: string
    name: string
    email: string
    department: string
    position: string
  }
  onClose: () => void
}

export function OvertimeHistory({ employee, onClose }: OvertimeHistoryProps) {
  const [startDate, setStartDate] = useState<Date | undefined>(undefined)
  const [endDate, setEndDate] = useState<Date | undefined>(undefined)
  const [view, setView] = useState("list")
  const [searchQuery, setSearchQuery] = useState("")

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold">Overtime History</h2>
        <p className="text-muted-foreground">View overtime records for {employee.name}</p>
      </div>

      <FilterBar 
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <Tabs defaultValue="list" value={view} onValueChange={setView}>
        <TabsList className="grid grid-cols-3 w-full md:w-auto">
          <TabsTrigger value="list">List View</TabsTrigger>
          <TabsTrigger value="charts">Charts</TabsTrigger>
          <TabsTrigger value="summary">Summary</TabsTrigger>
        </TabsList>
        
        <TabsContent value="list">
          <OvertimeList 
            employeeId={employee.id} 
            startDate={startDate} 
            endDate={endDate} 
            searchQuery={searchQuery}
          />
        </TabsContent>
        
        <TabsContent value="charts">
          <ChartView 
            employeeId={employee.id} 
            startDate={startDate} 
            endDate={endDate} 
            searchQuery={searchQuery}
          />
        </TabsContent>
        
        <TabsContent value="summary">
          <SummaryView 
            employeeId={employee.id} 
            startDate={startDate} 
            endDate={endDate} 
            searchQuery={searchQuery}
          />
        </TabsContent>
      </Tabs>
      
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outline" onClick={onClose}>Close</Button>
      </div>
    </div>
  )
}
